import Start from './forms/Start'
import Presta from './forms/Presta'
import Metier from './forms/Metier'
import Nature from './forms/Nature'
import Manif from './forms/Manif'
import Type from './forms/Type'
import Period from './forms/Period'
import Space from './forms/Space'
import Info from './forms/Info'
import Questions from './forms/Questions'
import Recap from './forms/Recap'

type ControleFormScreen = (props: ControleFormProps) => JSX.Element | null

const SCREENS: { [key in ControleStep]: ControleFormScreen } = {
  start: Start,
  presta: Presta,
  nature: Nature,
  manif: Manif,
  period: Period,
  metier: Metier,
  spaces: Space,
  type: Type,
  questions: Questions,
  info: Info,
  recap: Recap,
}

export { SCREENS }
